import React from 'react'
import PropTypes from 'prop-types'
import { InputField, Relative, Select } from 'pcln-design-system'

const propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
}

const renderOptions = (options) =>
  options.map((option) => (
    <option value={option.value} key={`sort-${option.value}`}>
      {option.label}
    </option>
  ))

const Dropdown = ({ className, options, onChange, defaultValue }) => {
  if (!options) return null
  return (
    <Relative>
      <InputField>
        <Select className={className} defaultValue={defaultValue} onChange={onChange}>
          <optgroup label='Sort-By-Drop-Down-List'>{renderOptions(options)}</optgroup>
        </Select>
      </InputField>
    </Relative>
  )
}

Dropdown.propTypes = propTypes
export default Dropdown
